import { Component, EventEmitter, Input, OnInit, Output, signal } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { MatIconButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { MatInput } from '@angular/material/input';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';

import { TSourceItem } from '@core/interfaces/TSourceItem';

import { TExternalReference } from '@core/api/sources/types';
import { SourcesService } from '@shared/services/sources.service';

@Component({
    selector: 'app-source-references-search',
    templateUrl: './source-references-search.component.html',
    styleUrls: ['./source-references-search.component.scss'],
    standalone: true,
    imports: [ReactiveFormsModule, MatInput, MatIconButton, MatIcon]
})
export class SourceReferencesSearchComponent implements OnInit {
  @Input() source: TSourceItem | undefined;
  /** When true, search bar stretches to container width (e.g. embedding references modal). */
  @Input() fullWidth = false;
  /** `toolbar` — compact field with leading search icon (for embedding references modal). */
  @Input() variant: 'default' | 'toolbar' = 'default';
  @Output() results = new EventEmitter<TExternalReference[]>();
  searchForm: FormGroup;

  protected readonly hasSearchText = signal(false);

  constructor(
    private sourcesService: SourcesService,
    private fb: FormBuilder
  ) {
    this.searchForm = this.fb.group({
      referenceText: [''],
    });
  }

  ngOnInit(): void {
    const ctrl = this.searchForm.get('referenceText');
    ctrl?.valueChanges.subscribe(value => {
      this.hasSearchText.set(!!(value != null && String(value).trim().length > 0));
    });
    ctrl?.valueChanges.pipe(debounceTime(300), distinctUntilChanged()).subscribe(value => {
      this.search(value);
    });
  }

  onSearch() {
    this.search(this.searchForm.get('referenceText')?.value);
  }

  onReset() {
    this.searchForm.reset();
    this.search('');
  }

  search(query: string): void {
    this.sourcesService.searchExternalReference(this.source!._id, query).subscribe(res => {
      this.results.emit(res);
    });
  }
}
